import { compact, join } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage, injectIntl } from 'react-intl';
import { LOCALIZED_STRINGS } from '../constants';
import BookingSectionTimesGrid from '../../BookingSectionTimesGrid';
import { FontFamily } from '@zocdoc/components/src/typography';
import { Alert, InvertedCheck } from '@zocdoc/components/src/icons';
import { breakpoint } from '@zocdoc/components/src/grid';
import { coral, green, navy } from '@zocdoc/branding/colors';

class LocationAppointmentPicker extends React.PureComponent {
    static propTypes = {
        insuranceIsValidating: PropTypes.bool,
        is1Z: PropTypes.bool,
        location: PropTypes.shape({
            monolithId: PropTypes.string,
            practiceName: PropTypes.string,
        }),
    };

    static defaultProps = {
        is1Z: false,
        insuranceIsValidating: true,
    };

    render() {
        const { location, ...props } = this.props;

        return (
            <Wrapper>
                <Header>
                    <PracticeName>{location.practiceName}</PracticeName>
                    <div>{buildAddress(location)}</div>
                    {this.maybeRenderInsuranceStatus(props)}
                </Header>
                <BookingSectionTimesGrid
                    {...props}
                    data-test="booking-section-timesgrid"
                    locationId={location.monolithId}
                />
            </Wrapper>
        );
    }

    maybeRenderInsuranceStatus() {
        const { insuranceIsAccepted, insuranceIsValidating, is1Z } = this.props;

        if (insuranceIsValidating) { return; }

        const InsuranceText = is1Z ? InsuranceText1Z : InsuranceText;

        if (insuranceIsAccepted) {
            return (
                <InsuranceText color={green}>
                    <InsuranceAcceptedIcon color={green} />
                    <FormattedMessage {...LOCALIZED_STRINGS.InsuranceAccepted} />
                </InsuranceText>
            );
        } else {
            return (
                <InsuranceText color={coral}>
                    <InsuranceNotAcceptedIcon color={coral} />
                    <FormattedMessage {...LOCALIZED_STRINGS.InsuranceNotAccepted} />
                </InsuranceText>
            );
        }
    }
}

export default injectIntl(LocationAppointmentPicker);

function buildAddress({
    address1,
    address2,
    city,
    state,
    zipCode,
}) {
    const parts = compact([address1, address2, city, state, zipCode]);
    return join(parts, ', ');
}

const Wrapper = styled.div`
    margin-top: 8px;
`;

const Header = styled.div`
    background-color: white;
    font-size: 13px;
    line-height: 1.6;
    margin-bottom: 2px;
    padding: 16px 25px;
    text-align: center;

    ${breakpoint.medium} {
        font-size: 15px;
    }
`;

const PracticeName = styled.div`
    ${breakpoint.medium} {
        font-family: ${FontFamily.SharpSansBold};
    }
`;

const InsuranceText = styled.div`
    align-items: center;
    color: ${p => p.color};
    display: flex;
    justify-content: center;
`;

const InsuranceText1Z = styled(InsuranceText)`
    font-size: 13px;

    ${breakpoint.medium} {
        color: ${navy};
    }
`;

const InsuranceStatusIcon = styled.div`
    font-size: 13px;
    margin-right: 8px;
    vertical-align: middle;
`;

const InsuranceAcceptedIcon = InsuranceStatusIcon.withComponent(InvertedCheck);
const InsuranceNotAcceptedIcon = InsuranceStatusIcon.withComponent(Alert);
